<template>
  <div>
    <h1 class="title">Unapproved POs</h1>
    <form @submit.prevent="loadData">
      <b-input placeholder="Search Unapproved POs..." v-model="search" rounded type="search" icon="search"></b-input>
    </form>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <b-table :data="orderData" narrowed>
      <template slot-scope="props">
        <b-table-column label="PO #">
          {{props.row.poNumber}}
        </b-table-column>
        <b-table-column label="Vendor Name">
          {{props.row.vendorName}}
        </b-table-column>
        <b-table-column label="">
            <button class="button" @click="edit(props.row.poNumber)">Edit</button>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';
import store from '../../store/store.js';

  export default {
  name: 'UnapprovedPOs',
  props: ['data'],
  data () {
    return {
      orderData: [],
      isLoading: false,
      isFullPage: false,
      search: ""
    }
  },
  computed:{
    ...mapState([
        'userInfo',
    ]),
    query(){
      if( this.search == ""){
        return [{
          "poNumber" : "*",
          "isApproved": "=",
          "isReceived": "=",
          "purchasingAgent": this.userInfo.employeeName
        }]
      }
      return [ 
        {
          "poNumber": this.search,
          "isApproved": "=",
          "isReceived": "=",
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "department": this.search,
          "isApproved": "=",
          "isReceived": "=",
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "isApproved": "=",
          "isReceived": "=",
          "purchasingAgent": this.search
        },
        {
          "vendorName": this.search,
          "isApproved": "=",
          "isReceived": "=",
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "orderDate": this.search,
          "isApproved": "=",
          "isReceived": "=",
          "purchasingAgent": this.userInfo.employeeName
        }
      ];
    },
    searchQuery(){
      var searchQuery = {
          "query": this.query,
          "sort":[{
              "fieldName": "poNumber",
              "sortOrder": "ascend"
          }]
      };
      return searchQuery;
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapMutations([
      'updateNewPoNumber'
    ]),
    loadData(){
      this.isLoading = true;
      var self = this;
      this.$http.post('api/v2/find.php?layout=purchaseOrder-dashboard-list', this.searchQuery)
      .then( response => {
          if(response.data.messages[0].code === "401"){
              this.$toast.open(response.data.messages[0].message);
              self.isLoading = false;
              return;
          }
          if(response.data.messages[0].code != 0){
              this.$toast.open(response.data.messages[0].message);
              self.isLoading = false;
              return;
          }
          self.orderData = [];
          response.data.response.data.forEach(function(record){
              self.orderData.push(record.fieldData);
          });

          self.isLoading = false;
      })
      .catch( error => {
          if (error.response) {
              this.$toast.open(error.response.status);
          } 
          else {
              this.$toast.open("Unknown Error");
          }
          self.isLoading = false;
      });
    },
    edit(orderID){
      this.$router.push({name: 'PurchaseOrderEditPage', params: { id: orderID }})
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .button {
    background-color: #d00a0b;
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/UnapprovedPOs.vue